import { useContext, useRef } from 'react';
import { withErrorBoundary } from '~/components/Tools';

import { LocalAuthContext } from '~/components/Auth';
import { useDatadog } from '~/components/Datadog';

import { DEFAULT_ERROR_FALLBACK as ErrorFallback } from '~/config/app.constants';

function Instrumentation({ enableDatadog }: { enableDatadog: boolean }) {
  const auth = useContext(LocalAuthContext);
  const integrationsAlreadyInitialized = useRef(false);

  const { initializeContext: initializeDatadogContext } = useDatadog(auth);

  if (!integrationsAlreadyInitialized.current) {
    enableDatadog && initializeDatadogContext();

    integrationsAlreadyInitialized.current = true;
  }

  return null;
}

export default withErrorBoundary(Instrumentation, {
  fallback: ({ error, ...rest }) => (
    <ErrorFallback error={error} {...rest} message="Error captured in Instrumentation" />
  ),
});
